import styles from "./StepMobile.module.scss";
import PropTypes from "prop-types";

const StepMobile = ({
  step,
  totalSteps,
  title,
  nextStepTitle,
  className,
  id,
  nextStepId,
}) => {
  const progress = (step / totalSteps) * 100;

  return (
    <div className={className}>
      {progress <= 100 && (
        <div className={styles["step-card"]}>
          <div
            className={styles["step-card__count"]}
          >{`Step ${step} of ${totalSteps}`}</div>
          <div
            className={styles["step-card__title"]}
            id={`checkout-step-${id}`}
          >
            {title}
          </div>
          {progress !== 100 && (
            <div
              className={styles["step-card__next"]}
              id={`checkout-step-${nextStepId}`}
            >{`Next: ${nextStepTitle}`}</div>
          )}
        </div>
      )}
      <div
        className={styles["step-card-progress"]}
        style={{ width: `${progress}%` }}
      ></div>
    </div>
  );
};

StepMobile.propTypes = {
  step: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  totalSteps: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  nextStepTitle: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string,
  nextStepId: PropTypes.string,
};

StepMobile.defaultProps = {
  className: "d-lg-none",
};

export default StepMobile;
